export class GDSFormEventHandler {
    constructor(builder) {
        this.builder = builder;
        this.state = builder.stateManager;
        this.orchestrator = builder.stepOrchestrator;
        this.cardManager = builder.cardManager;

        this.handleDropdownChange = this.handleDropdownChange.bind(this);
    }

    setupListeners() {
        this.builder.contentContainer?.addEventListener('change', this.handleDropdownChange);
        this.builder.addEventListener('click', this.handleButtonClick);
    }

    removeListeners() {
        this.builder.contentContainer?.removeEventListener('change', this.handleDropdownChange);
        this.builder.removeEventListener('click', this.handleButtonClick);
    }

    handleDropdownChange(e) {
        if (!e.target.matches('select[data-field]')) return;

        const dropdown = e.target;
        const field = dropdown.dataset.field;
        const value = dropdown.value;

        if (field === 'Device Make') {
            this.state.context.context['Device Make'] = value;
            const deviceModelSelect = this.builder.contentContainer.querySelector('select[data-field="Device Model"]');
            if (deviceModelSelect) {
                this.updateDeviceModelDropdown(value, deviceModelSelect);
            }
        } else if (field === 'Device Model') {
            this.state.context.context['Device Model'] = value;
        }

        this.orchestrator.updateButtonVisibility();
    }

    updateDeviceModelDropdown(deviceMake, deviceModelSelect) {
        const isEnabled = !!deviceMake;
        const pointerIcon = deviceModelSelect.parentElement.querySelector('.pointer-events-none');

        deviceModelSelect.disabled = !isEnabled;
        deviceModelSelect.classList.toggle('bg-gray-100', !isEnabled);
        deviceModelSelect.classList.toggle('text-gray-400', !isEnabled);
        pointerIcon?.classList.toggle('text-gray-400', !isEnabled);
        deviceModelSelect.classList.toggle('bg-white', isEnabled);
        deviceModelSelect.classList.toggle('text-gray-700', isEnabled);
        pointerIcon?.classList.toggle('text-gray-500', isEnabled);

        deviceModelSelect.innerHTML = '<option value="">Select Device Model</option>';
        if (isEnabled) {
            const modelOptions = this.state.context.options[deviceMake] || [];
            modelOptions.forEach(model => {
                const option = document.createElement('option');
                option.value = model;
                option.textContent = model;
                deviceModelSelect.appendChild(option);
            });
        }
        this.state.context.context['Device Model'] = '';
    }

    /**
     * @param {Event} e - The click event.
     */
    handleButtonClick(e) {
        const button = e.target.closest('button');
        if (!button) return;

        // Delegate to the correct manager/handler based on button ID
        switch (button.id) {
            case 'add-to-cart-btn':
            case 'add-to-cart-btn-desktop':
                // The cardManager holds the logic for this action
                this.cardManager.handleAddToCartClick();
                break;
            case 'share-btn':
            case 'share-btn-desktop':
                 // The cardManager holds the logic for this action
                this.cardManager.copyShareUrl();
                break;
        }
    }
}
